<template>
	<div v-if="!(dbValue === compareValue || compareValue === nullValue || compareValue == null)" class="detectable-alert-wrapper">
		<div class="detectable-alert-header">
			{{ $t(compareAlertKey) }}
		</div>
		<div class="detectable-alert-values">
			<div class="detectable-alert-key">
				{{ $t(dbLabelKey) }}
			</div>
			<div class="detectable-alert-value" v-html="dbValueDisplay" />
			<div class="detectable-alert-key">
				{{ $t(compareLabelKey) }}
			</div>
			<div class="detectable-alert-value" v-html="compareValueDisplay" />
		</div>
	</div>
</template>

<script>
import { computed, toRef } from 'vue';

import escape from 'lodash/escape';

import { useI18n } from 'vue-i18n';

export default {
	props: {
		dbValue: {
			type: String,
			required: true,
		},
		compareValue: {
			type: String,
			required: true,
		},
		nullValue: {
			type: String,
			required: true,
		},
		displayValuePrefix: {
			type: String,
			default: null,
			required: false,
		},
		compareAlertKey: {
			type: String,
			required: true,
		},
		dbLabelKey: {
			type: String,
			required: true,
		},
		compareLabelKey: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const { t } = useI18n();
		const dbValueRef = toRef(props, 'dbValue');
		const compareValueRef = toRef(props, 'compareValue');
		const displayValuePrefixRef = toRef(props, 'displayValuePrefix');
		const calcDisplayValue = (prefix, value) => prefix ? t(prefix + '.' + value) : escape(value).replace(/ /g, '<span class="detectable-alert-value-dot">·</span>');
		const dbValueDisplay = computed(() => calcDisplayValue(displayValuePrefixRef.value, dbValueRef.value));
		const compareValueDisplay = computed(() => calcDisplayValue(displayValuePrefixRef.value, compareValueRef.value));
		return {
			dbValueDisplay,
			compareValueDisplay,
		};
	}
}
</script>

<style scoped>
.detectable-alert-wrapper {
	color: #c41d7f;
	background: #fff0f6;
	box-sizing: border-box;
	margin-block-start: 8px;
	padding-inline: 7px;
	font-size: 12px;
	line-height: 20px;
	white-space: break-spaces;
	border: 1px solid #ffadd2;
	border-radius: 5px;
	max-width: 450px;
}

.detectable-alert-header {
	font-weight: bold;
	border-block-end: 1px solid #c41d7f;
}

.detectable-alert-values {
	display: grid;
	grid-template-columns: min-content min-content;
}

.detectable-alert-key,
.detectable-alert-value {
	margin-block: 3px;
	margin-inline-end: 4px;
	white-space: pre;
}

.detectable-alert-value {
	border-inline-start: 1px solid currentColor;
	border-inline-start: 1px solid color-mix(in srgb, currentColor 60%, transparent);
	padding-inline-start: 4px;
}
</style>

<style>
.detectable-alert-value-dot {
	padding-inline: 2px;
	opacity: 0.5;
}
</style>
